export class PrepayDTO {
    id?: number;
    time?: string;
    name?: string;
    email?: string;
    mobile?: number;
    amount?: number;
    description?: string;
    gateway?: string;
    status?: string;
    refId?: string;
}

export default class Prepay extends PrepayDTO{
    constructor(dto?: PrepayDTO) {
        super();
        if(dto) {
            Object.assign(this, dto);
        }
    }
}

